import { createUseStyles } from 'react-jss'
import { RecommendationsStyle } from './recommendations.types'

export const useStyle = createUseStyles({
  productList: {
    marginTop: ({ mobile }: RecommendationsStyle) => (mobile ? 80 : 48),
    textAlign: 'center'
  }
})
